import useUser from "@/api/apis";
import { useRecommendedContent } from "@/components/compatibility/experiences/hooks/useBhapticsContent";
import SelectGameKeyDialog from "@/components/compatibility/SelectGameKeyDialog";
import { BhapticsContent } from "@/store/reducers/contents";
import { useTrans } from "@/utils/useTrans";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/v2-components/ui/carousel";
import { Skeleton } from "@/v2-components/ui/skeleton";
import GameCard from "@/v2-components/pages/games/GameCard";
import Link from "next/link";
import React, { useState } from "react";

interface RecommendedGamesProps {
  contentId: string;
}

export default function RecommendedGames({ contentId }: RecommendedGamesProps) {
  const { t } = useTrans(["games"]);
  const { user } = useUser();
  const [content, setContent] = useState<BhapticsContent | null>(null);
  const { recommended, isLoading } = useRecommendedContent(contentId);

  return (
    <div>
      <h2 className="mx-4 mb-5 text-2xl laptop:mx-0 laptop:mb-8 laptop:text-3xl">
        {t("Games Discovered by Other Players")}
      </h2>
      <Carousel
        opts={{
          align: "start",
          slidesToScroll: 1,
        }}
        className="w-full"
      >
        {/* 시안 `29889:101596` — 카드 342 · 간격 **24** (342×4 + 24×3 = 1440). 종전 16. */}
        <CarouselContent className="ml-4 laptop:-ml-6">
          {isLoading &&
            Array.from({ length: 4 }).map((_, index) => {
              return (
                <div
                  key={index}
                  className="basis min-w-0 max-w-[90%] shrink-0 grow-0 basis-full pl-0 pr-4 smd:basis-1/3 laptop:basis-1/4 laptop:pl-6 laptop:pr-0"
                >
                  <Skeleton className="aspect-game-card-horizontal h-40 w-full rounded-lg bg-coolgray-10" />
                  <Skeleton className="mt-2 h-8 w-full rounded-md bg-coolgray-10" />
                  <div className="flex gap-2">
                    <Skeleton className="mt-2 h-6 w-20 rounded-md bg-coolgray-10" />
                    <Skeleton className="mt-2 h-6 w-20 rounded-md bg-coolgray-10" />
                  </div>
                  <div className="flex gap-2">
                    <Skeleton className="mt-2 h-6 w-20 rounded-md bg-coolgray-10" />
                    <Skeleton className="mt-2 h-6 w-20 rounded-md bg-coolgray-10" />
                    <Skeleton className="mt-2 h-6 w-20 rounded-md bg-coolgray-10" />
                  </div>
                </div>
              );
            })}
          {recommended?.map((game, index) => (
            <CarouselItem
              key={index}
              className="basis max-w-[90%] pl-0 pr-4 smd:basis-1/3 laptop:basis-1/4 laptop:pl-6 laptop:pr-0"
            >
              <GameCardComp
                isLoggedIn={!!user}
                game={game}
                onResellClick={(game) => setContent(game)}
              />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="invisible top-[80px] translate-x-1/3 disabled:invisible laptop:visible max:-translate-x-1/2" />
        <CarouselNext className="invisible top-[80px] -translate-x-1/3 disabled:invisible laptop:visible max:translate-x-1/2" />
      </Carousel>
      {content && (
        <SelectGameKeyDialog
          open={!!content}
          onOpenChange={() => setContent(null)}
          content={content}
        />
      )}
    </div>
  );
}

interface GameCardProps {
  isLoggedIn: boolean;
  game: BhapticsContent;
  onResellClick: (game: BhapticsContent) => void;
}
function GameCardComp({ isLoggedIn, game, onResellClick }: GameCardProps) {
  return (
    <GameCard isLoggedIn={isLoggedIn} className="tablet:w-auto" game={game}>
      <Link href={`/games/experiences/${game.slug}`} className="space-y-3">
        <GameCard.Image className="h-full w-full">
          <GameCard.ResellBanner onClick={() => onResellClick(game)} />
        </GameCard.Image>
        <GameCard.Title />
      </Link>

      <GameCard.Platforms className="gap-2 gap-y-0.5 laptop:gap-2" />
      <GameCard.Devices />
      <GameCard.Resell onClick={() => onResellClick(game)} />
    </GameCard>
  );
}
